import CanBoNhanVien from "./CanBoNhanVien";

export default CanBoNhanVien